import { commonAPI } from '@/services-ts/axios'
import type { IGetQuoteList, IPayloadQuote } from '@/types/Request'
import type { IQuoteStore } from '@/types/Store/State'
import { Alert, Format } from '@/utils-ts'
import { defineStore } from 'pinia'

export const useQuoteStore = defineStore('quote', {
  state: (): IQuoteStore => ({
    quotes: {
      data: [],
      total: 0,
    },
  }),

  actions: {
    async GetQuoteList(payload: IGetQuoteList) {
      const { status, data, total } = await commonAPI.QuoteServices.GetQuoteList(payload)
      this.quotes = status ? { data: data || [], total: total || 0 } : { data: [], total: 0 }
    },

    async CreateQuote(payload: IPayloadQuote) {
      const { status, data } = await commonAPI.QuoteServices.CreateQuote(payload)
      if (status && data) {
        if (this.quotes.data.length === 0 || this.quotes.data[0]?.languageId === data.languageId) {
          this.quotes.data.push(data)
          this.quotes.total += 1
        }
        void Alert({ message: Format('admin_global_success'), type: 'success' })
      }
      return status
    },

    async UpdateQuote(payload: IPayloadQuote) {
      const { status, data } = await commonAPI.QuoteServices.UpdateQuote(payload)
      if (status && data) {
        // Global (CompanyId: null) bir satır düzenlenirse backend fork oluşturup yeni bir Id döner,
        // bu yüzden eşleştirme response'daki data.id yerine gönderilen payload.Id ile yapılıyor.
        const index = this.quotes.data.findIndex(item => item.id === payload.Id)
        if (index !== -1) {
          this.quotes.data[index] = data
        }
        void Alert({ message: Format('admin_global_updated'), type: 'success' })
      }
      return status
    },

    async DeleteQuote(Id: string) {
      const { status } = await commonAPI.QuoteServices.DeleteQuote({ id: Id })
      if (status) {
        this.quotes.data = this.quotes.data.filter(item => item.id !== Id)
        this.quotes.total -= 1
        void Alert({ message: Format('admin_global_deleted'), type: 'success' })
      }
      return status
    },
  },
})
